import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CartItem from './CartItem';

import Description from 'ui/text/Description';
import Button from 'ui/Button';

import { useCart } from 'utils/CartContext';
import { currencySymbol } from 'utils/rewards';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';

import { t } from "i18n/index";

const CartDrawer = ({ onCheckout }) => {
  const [expanded, setExpanded] = useState(false);
  const { cartItems, cartTotal, cartItemCount } = useCart();

  if (cartItems.length === 0) return null;

  const currency = cartItems[0].product.currency;
  const currencySign = currencySymbol[currency];
  const formattedTotal = `${(cartTotal / 100).toFixed(2)} ${currencySign}`;

  return (
    <div className="cart-drawer">
      <div className="cart-drawer-bar" onClick={() => setExpanded(!expanded)}>
        <div className="cart-drawer-summary">
          <Badge badgeContent={cartItemCount} color="primary">
            <ShoppingCartIcon />
          </Badge>
          <Description bold className="cart-price">{formattedTotal}</Description>
        </div>

        <div className="cart-drawer-actions">
          <Button
            highlighted
            smallPadded
            onClick={(e) => {
              e.stopPropagation();
              onCheckout();
            }}
          >
            {t('literal:buyNow')}
          </Button>

          <IconButton size="small" onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
            {expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </div>
      </div>

      {expanded && (
        <div className="cart-drawer-items">
          {cartItems.map((item) => (
            <CartItem key={`${item.product.id}-${item.variant?.id || 0}`} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

CartDrawer.propTypes = {
  onCheckout: PropTypes.func.isRequired,
};

export default CartDrawer;
